import { useCallback, useRef } from 'react';

/* eslint-disable-next-line no-unused-vars */
type AnyFn = (..._: unknown[]) => unknown;

export function useLatestCallback<T extends AnyFn>(callback: T) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  return useCallback(
    (...args: Parameters<T>): ReturnType<T> =>
      callbackRef.current(...args) as ReturnType<T>,
    [],
  );
}
